"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var ScrollButton_1 = __importDefault(require("./ScrollButton"));
var TabItem_1 = __importDefault(require("./TabItem"));
var TabContent_1 = __importDefault(require("./TabContent"));
var ScrollDirection_1 = __importDefault(require("./ScrollDirection"));
var getClasses = function (props) {
    var classes = props.classes, scrollable = props.scrollable, children = props.children;
    var childProps = react_1.default.Children.map(children, function (child) { return child.props; });
    return classnames_1.default('fds-tabs', 'fds-grid', {
        'fds-tabs-scrollable': scrollable,
        'fds-tabs-fixed': !scrollable,
        'fds-tabs-icons-text': childProps.filter(function (props) { return props.iconName; }).length
    }, classes);
};
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabListRefContainer = react_1.default.createRef();
        _this.state = {
            selectedTabs: new Array(react_1.default.Children.count(_this.props.children)).fill(false),
            scrollDirection: ScrollDirection_1.default.NONE
        };
        _this.getScrollDirectionFromScrollPosition = function () {
            var tabList = _this.tabListRefContainer.current;
            if (tabList) {
                if (tabList.scrollLeft > 0 && tabList.scrollLeft + tabList.offsetWidth !== tabList.scrollWidth) {
                    return ScrollDirection_1.default.BOTH;
                }
                else if (tabList.scrollLeft > 0 && tabList.scrollLeft + tabList.offsetWidth === tabList.scrollWidth) {
                    return ScrollDirection_1.default.BACK;
                }
                else if (tabList.scrollLeft === 0 && tabList.offsetWidth !== tabList.scrollWidth) {
                    return ScrollDirection_1.default.FORWARD;
                }
            }
            return ScrollDirection_1.default.NONE;
        };
        _this.handleTabScrollClick = function (evt, tabList) {
            if (tabList) {
                var tabItemWidth = tabList.children[0].offsetWidth;
                var scrollPos = evt.target.parentElement.classList.contains('fds-tab-next') ?
                    tabList.scrollLeft + tabItemWidth * 2 :
                    tabList.scrollLeft - tabItemWidth * 2;
                tabList.scrollLeft = scrollPos;
            }
        };
        _this.handleTabListScroll = function () {
            _this.tabListRefContainer &&
                _this.setState(__assign(__assign({}, _this.state), { scrollDirection: _this.getScrollDirectionFromScrollPosition() }));
        };
        _this.onTabItemClickCallback = function (selected, index) {
            var onTabItemClick = _this.props.onTabItemClick;
            var tabSelectedState = _this.state.selectedTabs.map(function () { return false; });
            tabSelectedState[index] = selected;
            _this.setState(__assign(__assign({}, _this.state), { selectedTabs: tabSelectedState }));
            onTabItemClick && onTabItemClick(selected, index);
        };
        _this.handleTabListScrollable = function () {
            _this.setState(__assign(__assign({}, _this.state), { scrollDirection: _this.tabListRefContainer && _this.getScrollDirectionFromScrollPosition() }));
        };
        return _this;
    }
    Tabs.prototype.componentDidUpdate = function (prevProps, prevState) {
        var newScrollDirection = this.getScrollDirectionFromScrollPosition();
        if (prevState.scrollDirection !== newScrollDirection) {
            this.setState({
                scrollDirection: newScrollDirection
            });
        }
    };
    Tabs.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleTabListScrollable, false);
        this.setState({
            selectedTabs: react_1.default.Children.map(this.props.children, function (child) { return child.props.selected; }),
            scrollDirection: this.getScrollDirectionFromScrollPosition()
        });
    };
    Tabs.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleTabListScrollable);
    };
    Tabs.prototype.getContainer = function (childrenArray, selectedTabs, contentTopBorder) {
        var hasContent = childrenArray.some(function (child) {
            return child.props.children;
        });
        return hasContent && (react_1.default.createElement("div", { className: classnames_1.default('fds-tab-content-container', { 'top-border': contentTopBorder }) }, childrenArray.map(function (child, i) {
            return (react_1.default.createElement(TabContent_1.default, { key: i, selected: selectedTabs && selectedTabs[i], contentId: child.props.contentId, collapsePadding: child.props.collapsePadding }, child.props.children));
        })));
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, scrollable = _a.scrollable, contentTopBorder = _a.contentTopBorder, children = _a.children;
        var _b = this.state, selectedTabs = _b.selectedTabs, scrollDirection = _b.scrollDirection;
        var showBackScrollBtn = [ScrollDirection_1.default.BOTH, ScrollDirection_1.default.BACK].includes(scrollDirection);
        var showForwardScrollBtn = [ScrollDirection_1.default.BOTH, ScrollDirection_1.default.FORWARD].includes(scrollDirection);
        var childrenArray = react_1.default.Children.toArray(children);
        return (react_1.default.createElement("div", { className: getClasses(this.props) },
            scrollable && (react_1.default.createElement("div", { className: classnames_1.default('fds-tab-prev', { scrollable: showBackScrollBtn }) },
                react_1.default.createElement(ScrollButton_1.default, { onClick: function (evt) { return _this.handleTabScrollClick(evt, _this.tabListRefContainer.current); }, direction: ScrollDirection_1.default.BACK }))),
            react_1.default.createElement("div", { className: "fds-tabs-list-container" },
                react_1.default.createElement("ul", { role: "tablist", className: "fds-tab-list", ref: this.tabListRefContainer, onScroll: this.handleTabListScroll }, childrenArray.map(function (child, i) {
                    return (react_1.default.createElement(TabItem_1.default, __assign({}, child.props, { onClick: _this.onTabItemClickCallback, selected: selectedTabs && selectedTabs[i], key: i, index: i }), child.props.children));
                }))),
            scrollable && (react_1.default.createElement("div", { className: classnames_1.default('fds-tab-next', { scrollable: showForwardScrollBtn }) },
                react_1.default.createElement(ScrollButton_1.default, { onClick: function (evt) { return _this.handleTabScrollClick(evt, _this.tabListRefContainer.current); }, direction: ScrollDirection_1.default.FORWARD }))),
            this.getContainer(childrenArray, selectedTabs, contentTopBorder)));
    };
    Tabs.defaultProps = {
        scrollable: true
    };
    return Tabs;
}(react_1.default.Component));
exports.default = Tabs;
